module.exports = __webpack_public_path__ + "img/ico_zanting.d27521fd.svg";